import { ActorAccessRedirect } from './ActorAccessRedirect';

/**
 * Перенаправление на страницу кастинга для актера
 */
export const ActorCastingAccessRedirect = () => {
  return <ActorAccessRedirect resourceType='кастинг' />;
};
